import { useTranslation } from "react-i18next";
import CustomTabs from "../../Components/CustomTabButton";
import stripeTabImg from "../../Images/Owision/stripeTabImg.png";
import riderImg from "../../Images/Owision/shopifyTabImage.png";
import CarouselTab from "../../Components/Carousel ";
import mondayTabImage from "../../Images/mondayTabImage.png";
import reviewTabImage from "../../Images/reviewTabImage.png";
import synctosheetTabImage from "../../Images/synctosheetTabImage.png";
import invoiceTabImage from "../../Images/invoiceTabImage.png";

const ShopifyFeature = () => {
  const { t } = useTranslation();

  const shopifyContent = [reviewTabImage, riderImg];
  const stripeContent = [stripeTabImg, synctosheetTabImage, invoiceTabImage];
  const mondayContent = [mondayTabImage];

  const tabs = [
    { id: "shopify", label: "Shopify", content: <CarouselTab content={shopifyContent} /> },
    { id: "stripe", label: "Stripe", content: <CarouselTab content={stripeContent} /> },
    { id: "monday", label: "Monday", content: <CarouselTab content={mondayContent} /> },
  ];

  return (
    <div>
      <div className="foodrna-featurework">
        <h2 className="">{t("shopifyStripe.content.feature.title")}</h2>
        <div className="the-art-flavour">
          <CustomTabs tabs={tabs} defaultActiveTab="shopify" />
        </div>
      </div>
    </div>
  );
};

export default ShopifyFeature;
